'use strict';
import {stateGo} from 'redux-ui-router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/switchMap';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {firebaseAuthSuccess} from '../actions';
import {getLoginView} from '../router';
import {logger} from './logger';


export const epics = [
  onAuthSuccess,
];

onAuthSuccess.$inject = [
  'AuthService',
  'UserDomain',
];

/**
 * All authentication is complete, we can now retrieve data
 *
 * Note: This epic currently does not emit any actions directly, deferring to the legacy code.
 * It will need to pass off the retrieved user data to the model when the $model domain wrapper is ready
 *
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param dependencies
 * @return {Observable<ReduxAction>}
 */
export function onAuthSuccess(action$, store, dependencies) {
  return action$.ofType(firebaseAuthSuccess.TYPE)
    .switchMap(action =>
      // TODO(redux): begin observing the user id location instead of using Angular Domain here
      getUser(action.payload.userId)
        .then(user => {
          dependencies.AuthService._withUser(user);
        })
        .catch((err) => {
          logger.error({err}, 'onAuthSuccess failed to retrieve user. Redirecting to login');
          return stateGo(getLoginView());
        })
    )
    .filter((action) => !!action)
    .catch(epicErrorHandler(logger, 'onAuthSuccess'));

  function getUser(userId) {
    return dependencies.UserDomain.$get(userId);
  }
}



// WEBPACK FOOTER //
// ./src/js/auth/epics/onAuthSuccess.js